import { render, staticRenderFns } from "./SlideOut.vue?vue&type=template&id=2327de58&"
import script from "./SlideOut.vue?vue&type=script&lang=js&"
export * from "./SlideOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports